import React from "react"
import {Icon, Segment} from "semantic-ui-react"
import api from "../api"
import OrderSummary from "./components/OrderSummary"
import {ContactPersons} from "./HomePage"
import {useTranslation} from 'react-i18next'

const SummaryPage = () => {
  const {t} = useTranslation();
  let order    = api.getOrder();

  return (
    <div>
      <div className="transition-item ph2 pt5">
        <div className="section-full section--center color-light">
          <h2 className="tc white pb3">{t("protocol.final")}</h2>
          <Segment color="green"
                   inverted>
            <Icon name="checkmark"/>{t("general.transferred")}
          </Segment>
          <OrderSummary order={order} children={<ContactPersons/>}/>
          <div className="footer tc pt5 pb4">
            <a target="_blank" className="f5 white-30" href="http://simplias.com/index.php/impressum/"> {t("general.imprint")}</a>
          </div>

        </div>
      </div>
    </div>
  )
}

export default SummaryPage

// const TechSignature = () => {
//   let techSignature     = _.first(api.order.Documents.filter(doc => doc.FileName === "Unterschrift externer Techniker"))
//   let subContractor     = api.getSubcontractor()
//   let subContractorName = `${subContractor.FirstName} ${subContractor.LastName}`
//   return (
//     <div>
//       <Segment className="tc">
//         <Image style={{margin: "auto"}} src={techSignature.URI}/>
//         <Divider horizontal>{subContractorName}</Divider>
//       </Segment>
//     </div>
//   )
// }



// WEBPACK FOOTER //
// ./src/pages/SummaryPage.js